<template>
  <v-autocomplete
    color="primary"
    v-model="materialsSelected"
    :clearable="!unclearable"
    :items="materialsItems"
    :loading="materialsLoading"
    :search-input.sync="materialsSearch"
    item-value="material_id"
    item-text="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Material.title')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import StockMaterials from "@/api/stock_materials";

export default {
  name: "SearcherStockMaterial",

  props: {
    stockId: Number,
    value: Object,
    noLabel: Boolean,
    label: String,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    exitStockDetail: Number,
    status: Array,
    typeFlg:String,
  },

  computed: {
    materialsItems() {
      return this.materials.map((material) => {
        const Description = this.dense
          ? material.material_name
          : i18n.t(
              this.settings
                ? this.settings.material_name_display_type == 4
                  ? "Material.nameWithCodeAndStandard"
                  : this.settings.material_name_display_type == 3
                  ? "Material.materialNameWithCodeAndStandard"
                  : this.settings.material_name_display_type == 2
                  ? "Material.materialNameWithCode"
                  : "Material.materialName"
                : "Material.materialName",
              [
                material.material_code,
                material.material_name,
                material.standard_name ? (material.standard_name.length > 12 ? material.standard_name.slice(0, 12) + "......" : material.standard_name) : "",
              ]
            );
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.material_id == material.material_id
            )
          : false;
        return Object.assign({}, material, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    materials: [],
    materialsLoading: false,
    materialsSearch: "",
    materialsSelected: null,
    monitorTime: null,
  }),

  methods: {
    getMaterialsFromAPI() {
      let postData = {
        stock_id: this.stockId,
        readonly: 0,
        exist_stock_detail: this.exitStockDetail,
        status: this.status ? this.status : [],
      };
      if (this.typeFlg) {
        postData.type_flg = this.typeFlg
      }
      this.materialsLoading = true;
      StockMaterials.fetchAllForSelect(postData)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materials = response.data.materials;
            }
            this.materialsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialsSelected = this.value;
      },
    },
    materialsSelected: {
      handler() {
        if (this.materialsSelected && this.materialsSelected.id)
          this.$emit("input", this.materialsSelected);
      },
    },
    stockId: {
      immediate: true, //初始赋值也调用
      handler() {
        if (typeof this.stockId != "undefined" && this.stockId != null)
          this.getMaterialsFromAPI();
      },
    },
  },
};
</script>
